module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sb-22224fa1c1bf800c3bfb461f002ad5bd.svg";